import _ from 'underscore';

/**
 * @author code-crash
 * @description - This file contains the simple validations with the help of regex
 * @file validator.js
 */

/**
 *
 * @param {string} email
 *
 * @returns {boolean} - Will return true for valid email and false for invalid email
 */
const EMAIL = (email) => {
  const re =
    /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const validateNumber = (val) => {
  const RE = /^(\s*|\d+)+([.]\d{0,2})?$/;
  if (val.indexOf('.') > 0 || !isNaN(val)) {
    return RE.test(val);
  }
  return false;
};

const CHECK_NON_EMPTY_ARRAY = function (data) {
  return data && _.isArray(data) && _.isEmpty(data) !== true;
};

const checkIfArrayNotEmpty = (data) => {
  return data && _.isArray(data) && _.isEmpty(data) !== true;
};

const checkIfDictionaryNotEmpty = (data) => {
  return (
    data &&
    _.isObject(data) &&
    _.isArray(data) !== true &&
    _.isEmpty(data) !== true
  );
};

const checkValue = (value) => {
  let result = false;
  if (value !== undefined && value !== '' && value !== null) {
    result = true;
  }
  return result;
};

const isValidJSON = (str) => {
  try {
      JSON.parse(str);
      return true;
  } catch (e) {
      return false;
  }
};

export {
  EMAIL,
  validateNumber,
  checkIfArrayNotEmpty,
  checkIfDictionaryNotEmpty,
  CHECK_NON_EMPTY_ARRAY,
  checkValue,
  isValidJSON
};
